import React from 'react';
import SupportServicesTable from './SupportServicesTable';

const SupportServicesAgent = ({data, timePeriodFilter}) => {
  return (
       <SupportServicesTable data={data} timePeriodFilter={timePeriodFilter} type="resolver" />
  );
};

export default SupportServicesAgent;
